import ShProgressBar from "@/components/Helpers/ShProgressBar";
// @vue/component
export default {
  name: "ProgressBar",

  components: {
    ShProgressBar
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    interval: {
      type: Number,
      default: 10
    },
    isOnHold: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      percentage: 0,
      counter: 0,
      customColor: "#f5f0e4",
      onePercent: 1
    };
  },
  created() {
    this.onePercent = 100 / this.interval;
  },
  watch: {
    isActive: function() {
      if (this.isActive) {
        this.counter = this.interval;
        this.timer = setInterval(() => {
          if (this.percentage < 100) {
            this.percentage += this.onePercent;
            this.counter -= 1;
          } else {
            this.$emit("fetchData");
            clearInterval(this.timer);
          }
        }, 1000);
      } else {
        clearInterval(this.timer);
        this.percentage = 0;
      }
    }
  }
};
